// extracted by mini-css-extract-plugin
export default {"container":"CountrySelect_container__h58Zw","label":"CountrySelect_label__lG93v","valueBox":"CountrySelect_valueBox__PoJQG","value":"CountrySelect_value__12QE2"};